import * as t from '../../actions/cafeteria/costs';

const initState = {
  result: 'none',
  loading: false,
  err: '',
  spent: {},
  balance: {},
};

export default function reducer(state = initState, action) {
  switch (action.type) {

    case t.CAFETERIA_COSTS_FAIL:
      return {
        ...state,
        err: action.payload.err,
        loading: false,
      };

    case t.CAFETERIA_COSTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case t.CAFETERIA_COSTS_SUCCESS:
      return {
        ...state,
        spent: {},
        balance: {},
        ...action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
